import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import './HeroSection.css';

const HeroSection = () => {
  const [currentText, setCurrentText] = useState("Distribuidores");
  const [fadeClass, setFadeClass] = useState("fade-in");

  useEffect(() => {
    const texts = ["Distribuidores", "Mayoristas", "Vendedores"];
    let index = 0;

    const interval = setInterval(() => {
      setFadeClass("fade-out");

      setTimeout(() => {
        index = (index + 1) % texts.length;
        setCurrentText(texts[index]);
        setFadeClass("fade-in");
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-section">
      <img
        src="/img/hero-image.png"
        alt="Hero"
        className="hero-image animated-image"
      />
      <div className="hero-overlay animated-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title animated-title">"Simplifica tu gestión, impulsa tu negocio."</h1>
        <h2 className={`hero-animated-text animated-text ${fadeClass}`} aria-live="polite">
          {currentText}
        </h2>
        <button className="hero-button animated-button">
          <ScrollLink to="contact" smooth={true} duration={500}>
            CONTACTO
          </ScrollLink>
        </button>
      </div>
    </div>
  );
};

export default HeroSection;



